import { CreateOrderType } from "Pages/Orders/CreateOrder/components/Patient/components/types";
import API from "Services/Api";

export const createBudgetOrder = async (order: CreateOrderType) => {
  try {
    const createdOrder = await API.post('/orders/colabi/data', {
      ...order
    })

    return createdOrder.data

  } catch (err) {
    console.error(err);
    throw "Ops! Ocorreu um erro ao criar o pedido";
  }
}